const _ = 24, E = 8, O = 4;
export {
  _ as C,
  E as M,
  O as S
};
